module.exports = __webpack_public_path__ + "img/02.e32437d7.png";